import { useStoreCtx } from 'src/store'
import InputSearch from '../input-search'
import s from './header.module.scss'
import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import {v4 as uuidv4} from "uuid";

export const HeaderComponent = observer(() => {
  const httpService = useStoreCtx().appStore

  function auth() {
    if (!httpService.userId) return webSsoAuth()
    window.location.assign(encodeURI(`https://kion.ru/profile`))
  }
  
  function webSsoAuth() {
    const hostUrl = window.location.host
    window.location.assign(encodeURI(`https://prod.tvh.mts.ru/tvh-public-api-gateway/public/rest/general/websso/redirect?state=${ uuidv4() }devices&clientType=WEB&domain=${hostUrl}`))
  }

  return (
    <header className={s.header}>
      <Link to="/" className={s.logo}>
        <img className={s.mobileLogo} src="/header/logo-mob.svg" />
      </Link>
      
      <div className={s.wrapper}>
        <Link to="/" className={s.logo}>
			<svg width="122" height="38" viewBox="0 0 280 59" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M0 58.3223V0H18.7464V22.9956L33.577 0H54.1564L34.91 28.4946L54.1564 58.3223H32.2439L18.7464 36.0765V58.3223H0ZM56.9059 58.3223V0H75.6523V32.7438L93.7322 0H114.395V58.3223H95.6485V25.5785L77.5686 58.3223H56.9059ZM221.875 58.3223V0H240.621V20.4128H261.034V0H279.78V58.3223H261.034V37.9095H240.621V58.3223H221.875ZM140.64 39.9924H195.63V18.3299H140.64V39.9924ZM121.06 58.3223V0H215.209V58.3223H121.06Z" fill="white"/>
			</svg>
        </Link>

        <div className={s.nav}>
        <a
          href="https://kion.ru/home">
          <span>
          Главная
          </span>
        </a>
        <a
          href="https://kion.ru/tv">
          <span>
          Телеканалы
          </span>
        </a>
        <a
          href="https://kion.ru/video">
          <span>
          Фильмы
          </span>
        </a>
        <a
          href="https://kion.ru/series">
          <span>
          Сериалы
          </span>
        </a>
        </div>

        <InputSearch/>

        <div className={s.enter}>
          {!httpService.userId ? (
            <a className={s.enterBtn}
              onClick={auth}
            >
              Войти
            </a>
          ) : (
            <a className="d-flex align-items-center" href="https://kion.ru/my/profile">
              <img
                className={s.profileAvatar}
                src={httpService.userAvatar || undefined}
                alt="Текущий пользователь"/>
            </a>
          )}
        </div>
      </div>
    </header>
  )
})